import { type SingleDomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'

export const navigationViewAccessControl: SingleDomainAccessControlConfig = {
  featureEntitlementIds: [FeatureEntitlements.Navigation],
  permissions: [Permission.StoreConfigsView, Permission.StorefrontStorefrontNavigationView],
  restrictedBannersAllowed: true,
}

export const navigationModifyAccessControl: SingleDomainAccessControlConfig = {
  featureEntitlementIds: [FeatureEntitlements.Navigation],
  permissions: [Permission.StoreConfigsModify],
  restrictedBannersAllowed: true,
}

export const departmentNavigationAccessControl: SingleDomainAccessControlConfig = {
  permissions: [Permission.DepartmentsView, Permission.CollectionsView],
  restrictedBannersAllowed: true,
}

export const navigationOpenContentPageFlyoutAccessControl: SingleDomainAccessControlConfig = {
  featureEntitlementIds: [FeatureEntitlements.PageBuilderNavigateToFlyoutModal],
}
